import { render } from "./QuoteDetail.vue?vue&type=template&id=cda396e8&scoped=true"
import script from "./QuoteDetail.vue?vue&type=script&lang=js"
export * from "./QuoteDetail.vue?vue&type=script&lang=js"

import "./QuoteDetail.vue?vue&type=style&index=0&id=cda396e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cda396e8"]])

export default __exports__